module.exports = __webpack_public_path__ + "static/media/slide-1.3f402b24.jpg";